// formatter translation strings
import Cookies from 'js-cookie';

const DIVISIONS = [
  { amount: 60, name: 'seconds' },
  { amount: 60, name: 'minutes' },
  { amount: 24, name: 'hours' },
  { amount: 7, name: 'days' },
  { amount: 4.34524, name: 'weeks' },
  { amount: 12, name: 'months' },
  { amount: Number.POSITIVE_INFINITY, name: 'years' },
] as const;

function getSocrativeLanguage() {
  return Cookies.get('socrative_lang') || 'en';
}

interface XAgoFormatterParams {
  /* stringthat can be formatted as a date */
  date: string;
  /* function that returns a locale. Will default to getSocrativeLanguage */
  getLocale?: () => string;
}

export function xAgoFormatter({
  date,
  getLocale = getSocrativeLanguage,
}: XAgoFormatterParams) {
  const locale = getLocale();

  // For unsupported browsers (e.g. Safari 13). Polyfill requires additional side-effect updates
  if (!Intl['RelativeTimeFormat']) {
    return new Date(date).toLocaleDateString(locale, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }

  const formatter = new Intl.RelativeTimeFormat(locale, {
    numeric: 'auto',
  });

  const stamp = new Date(date).getTime();
  const current = Date.now();
  let interval = (stamp - current) / 1000;
  for (let i = 0; i <= DIVISIONS.length - 1; i++) {
    const division = DIVISIONS[i];
    if (Math.abs(interval) < division.amount) {
      return formatter.format(Math.round(interval), division.name);
    }
    interval /= division.amount;
  }
}
